import { SessionDetail, Store } from 'containers/my_sessions/types';

export enum StyleItemSortType {
    DATE_ADDED = 'Newly Added',
    ASCENDING_STYLE_TITLE = 'Style Title (A-Z)',
    DESCENDING_STYLE_TITLE = 'Style Title (Z-A)',
    ASCENDING_ITEM_TITLE = 'Item Title (A-Z)',
    DESCENDING_ITEM_TITLE = 'Item Title (Z-A)',
}

export enum StylingSessionOutcomeType {
    Style = 'STYLE',
    Item = 'ITEM',
    StyleGuide = 'STYLE_GUIDE',
}

export interface StylingSessionOutcome {
    id: string;
    sessionTaffiId: string;
    type: StylingSessionOutcomeType;
    style: StyleResponse;
    styleGuide: StyleGuideResponse;
    item: ItemResponse;
    created: string;
    creator: string;
    productTaffiId: string;
    stylingSession: SessionDetail;
}

export interface StyleGuideResponse {
    id: string;
    customerId: string;
    stylistId: string;
    creator: string;
    created: string;
    styleGuideUrl: string;
}
export interface StyleResponse {
    id: string;
    created: string;
    collection: string;
    taffiId: string;
    title: string;
    description: string;
    images: string[];
    items: ItemInfoResponse[];
    currency: string;
    price: number;
    status: string;
}

export interface ItemInfoResponse {
    id: string;
    data: ItemData;
}

export interface ItemData {
    id: string;
    collection: string;
    taffiId: string;
    price: number;
    currency: string;
    title: string;
    description: string;
    url: string;
    images: string[];
    storeId: string;
    store: Store;
}

export interface ItemResponse {
    id: string;
    collection: string;
    taffiId: string;
    price: number;
    currency: string;
    available: any;
    title: string;
    description: string;
    url: string;
    images: string[];
    maxNumOfStyles: any;
    maxNumOfItems: any;
    creator: string;
    created: string;
    status: string;
    inStock: string;
    storeId: string;
}

export enum sessionStyleFilterType {
    CONSUMER_STYLES = 'consumer_items',
    ALL_STYLES = 'all_styles',
}
